import AppURLs from '../config/urls'

// 🔐 Authentication Service
class AuthService {
  
  // Login function
  async login(username, password) {
    try {
      const response = await fetch(`${AppURLs.API}${AppURLs.AUTH.LOGIN}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username,
          password
        })
      })

      const data = await response.json()

      if (data.success) {
        // Store tokens and user data
        localStorage.setItem('tezlaa-access-token', data.data.tokens.access.token)
        localStorage.setItem('tezlaa-refresh-token', data.data.tokens.refresh.token)
        localStorage.setItem('tezlaa-user', JSON.stringify(data.data.user))
        
        return {
          success: true,
          user: data.data.user,
          tokens: data.data.tokens
        }
      } else {
        return {
          success: false,
          error: data.message || 'Login failed'
        }
      }
    } catch (error) {
      console.error('Login error:', error)
      return {
        success: false,
        error: 'Network error. Please check your connection.'
      }
    }
  }

  // Logout function - Updated for real API
  async logout() {
    try {
      const refreshToken = localStorage.getItem('tezlaa-refresh-token')
      
      if (refreshToken) {
        // Call the logout endpoint
        const response = await fetch(`${AppURLs.API}${AppURLs.AUTH.LOGOUT}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            refreshToken
          })
        })

        const data = await response.json()
        
        // Return the response data so we can show appropriate toast
        return {
          success: data.success || response.ok,
          message: data.message || 'Logout successful'
        }
      }
      
      return { success: true, message: 'Logout successful' }
    } catch (error) {
      console.error('Logout API call failed:', error)
      // Return error info for toast
      return {
        success: false,
        message: 'Network error during logout'
      }
    } finally {
      // Always clear local storage
      localStorage.removeItem('tezlaa-access-token')
      localStorage.removeItem('tezlaa-refresh-token')
      localStorage.removeItem('tezlaa-user')
    }
  }

  // Check if user is authenticated
  isAuthenticated() {
    const token = localStorage.getItem('tezlaa-access-token')
    const user = localStorage.getItem('tezlaa-user')
    return !!(token && user)
  }

  // Get current user
  getCurrentUser() {
    const userData = localStorage.getItem('tezlaa-user')
    return userData ? JSON.parse(userData) : null
  }

  // Get access token
  getAccessToken() {
    return localStorage.getItem('tezlaa-access-token')
  }

  // Refresh token function (for future use)
  async refreshToken() {
    try {
      const refreshToken = localStorage.getItem('tezlaa-refresh-token')
      
      if (!refreshToken) {
        throw new Error('No refresh token available')
      }

      console.log('🔄 AuthService: Attempting token refresh...')

      const response = await fetch(`${AppURLs.API}${AppURLs.AUTH.REFRESH}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          refreshToken
        })
      })

      const data = await response.json()

      console.log('✅ AuthService: Refresh response:', { success: data.success, hasTokens: !!data.data?.tokens })

      if (data.success && data.data?.tokens) {
        localStorage.setItem('tezlaa-access-token', data.data.tokens.access.token)
        localStorage.setItem('tezlaa-refresh-token', data.data.tokens.refresh.token)
        return data.data.tokens.access.token
      } else {
        console.error('❌ AuthService: Token refresh failed:', data.message)
        throw new Error(data.message || 'Token refresh failed')
      }
    } catch (error) {
      console.error('❌ AuthService: Refresh error:', error)
      
      // Only logout if it's actually an auth failure, not network error
      if (error.response?.status === 401 || error.response?.status === 403) {
        this.logout()
      }
      
      throw error
    }
  }
}

export default new AuthService()